import './style.less';

require('./pager/pager');
require('./breadcrumbs/breadcrumbs');
require('./bookmark/bookmark');
require('./modal/modal');
require('./product-carusel/product-carusel');

import LazyLoad from 'vanilla-lazyload';

window.lazyLoad = new LazyLoad({
    elements_selector: '.lazy',
});
